/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Win4_DInputs */

const en_wc_vs_win4_d = /** @type {(inputs: Wc_Vs_Win4_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No account, no cloud sign-in. Spelling and grammar run on your machine.`)
};

/**
* | output |
* | --- |
* | "No account, no cloud sign-in. Spelling and grammar run on your machine." |
*
* @param {Wc_Vs_Win4_DInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_win4_d = /** @type {((inputs?: Wc_Vs_Win4_DInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Win4_DInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_win4_d(inputs)
});
export { wc_vs_win4_d as "wc.vs.win4.d" }